module.exports = __webpack_public_path__ + "img/mark_chat_read.1af1a855.svg";